var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_164_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_239_",
    d: "M19.24,11.71H6.76c-2.77,0-5.02-2.25-5.02-5.02s2.25-5.02,5.02-5.02h12.47c2.77,0,5.02,2.25,5.02,5.02 S22.01,11.71,19.24,11.71z M6.76,3.39c-1.81,0-3.29,1.48-3.29,3.29s1.48,3.29,3.29,3.29h12.47c1.81,0,3.29-1.48,3.29-3.29 s-1.48-3.29-3.29-3.29H6.76z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_163_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_236_",
    d: "M19.24,24.66H6.76c-2.77,0-5.02-2.25-5.02-5.02v-0.19c0-2.77,2.25-5.02,5.02-5.02h12.47 c2.77,0,5.02,2.25,5.02,5.02v0.19C24.26,22.41,22.01,24.66,19.24,24.66z M6.76,16.16c-1.81,0-3.29,1.48-3.29,3.29v0.19 c0,1.82,1.48,3.29,3.29,3.29h12.47c1.81,0,3.29-1.48,3.29-3.29v-0.19c0-1.82-1.48-3.29-3.29-3.29H6.76z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_162_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_387_",
    cx: 19.06,
    cy: 6.69,
    r: 2.17
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_161_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_386_",
    cx: 7.15,
    cy: 19.54,
    r: 2.17
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleGroup);
export default __webpack_public_path__ + "static/media/ToggleGroup.a68fd905c7e8691921bfac917339230b.svg";
export { ForwardRef as ReactComponent };